import React, { useContext, useEffect, useState } from "react";
import Screen from "../../components/Screen";
import FormField from "../../components/FormField";
import { ChecklistContext } from "../../hooks/checklistContext";
import { Box, Grid, Typography } from "@mui/material";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import SubmitButton from "../../components/SubmitButton";
import { keys } from "../../config/keys";
import useAlert from "../../hooks/useAlert";

import Loader from "../../components/Loader";
import {
  Link,
  useLocation,
  useNavigate,
  useSearchParams,
} from "react-router-dom";
import usePolicy from "../../hooks/usePolicy";
import useAuth from "../../hooks/useAuth";
import useCompanies from "../../hooks/useCompanies";

export default function Default() {
  const {
    loading,
    handleAssistentRequest,
    handleEditorChange,
    aiLoading,
    newPolicy,
    data,
    setData,
    aiRequest,
    setAiRequest,
    getPolicy,
    updatePolicy,
    signatureType,
    setSignatureType,
    signatureHandler, 
    setsignatureHandler
  } = usePolicy();

  const { showAlert } = useAlert();
  const { isCompany } = useAuth();
  const navigate = useNavigate();
  const { companies, fetchCompanies } = useCompanies();
  const { categories } = useContext(ChecklistContext);
  const { isAdmin } = useAuth();
  const location = useLocation();
  const [query] = useSearchParams();
  const policyID = query.get("id");
  const assistantField = {
    value: aiRequest,
    setValue: (value) => {
      setAiRequest(value);
    },
    placeholder: "Search Anything Here...",
    type: "text",
    id: "aiRequest",
  };
  const titleField = {
    value: data?.title,
    setValue: (value) => {
      setData({ ...data, title: value });
    },
    placeholder: "Enter Policy title",
    type: "text",
    id: "title",
  };
  const categoryField = {
    type: "dropdown",
    options: categories,
    placeholder: "Select Policy Category",
    value: data?.categoryID,
    setValue: (value) => {
      setData({
        ...data,
        categoryID: value == "Select Policy category" ? "" : value,
      });
    },
    id: "categoryID",
  };
  const signatureTypeField = {
    type: "dropdown",
    options: ["File", "Text", "Signature"],
    placeholder: "Select Signature Type",
    value: signatureType,
    setValue: (value) => {
      setSignatureType(value);
    },
    id: "signatureType",
  };
  const companyField = {
    type: "dropdown",
    options: companies,
    placeholder: "Select Company",
    value: data?.companyID,
    setValue: (value) => {
      setData({ ...data, companyID: value == "Select Company" ? "" : value });
    },
    id: "companyID",
  };
  const signatureField = {
    value: [signatureHandler],
    setValue: async (value, checkbox) => {
      setsignatureHandler(value);
    },
    type: "signature",
  }
  const fileField = {
    type: "file",
    placeholder: "Select checklist category",
    value: data?.signature,
    setValue: async (value) => {
      try {
        const formData = new FormData();
        formData.append("image", value);
        await fetch(`${keys.BASE_URL}/file/upload`, {
          method: "POSt",
          body: formData,
        })
          .then((res) => res.json())
          .then((response) => {
            if (response.status) {
              setData({ ...data, signature: response.result });
              showAlert(response.message, "success");
            } else {
              showAlert(response.message, "danger");
            }
          });
      } catch (error) {
        showAlert("unexpected error! Try again later.", "danger");
      }
    },
    id: "signature",
  };
  const signatureTextField = {
    value: data?.signature,
    setValue: (value) => {
      setData({ ...data, signature: value });
    },
    placeholder: "Enter Your Name",
    type: "text",
    id: "signature",
  };
  const modules = {
    toolbar: [[{ header: [1, 2, false] }], ["bold"]],
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "list",
    "bullet",
    "link",
    "image",
  ];
  const autofillList = [
    "[[CompanyEmail]]",
    "[[CompanyName]]",
    "[[CompanyRole]]",
    "[[CompanyNature]]",
    "[[CompanyNoOfEmployees]]",
    "[[CompanyWebsite]]",
    "[[CompanyTelephone1]]",
    "[[CompanyNoOfBranches]]",
    "[[CompanyAddress]]",
    "[[CompanyWorkStartTime]]",
    "[[CompanyWorkEndTime]]",
    "[[AdminName]]",
    "[[AdminEmail]]",
  ];
  useEffect(() => {
    if (isAdmin) fetchCompanies();
  }, []);
  useEffect(() => {
    if (policyID || location.state?._id) {
      getPolicy(policyID || location.state?._id);
    }
  }, [policyID]);

  return (
    <Screen
      loading={loading}
      faqsId={"add_policy"}
      flow={[
        { label: "Policy", to: "/policyInput" },
        { label: "Home", to: "/" },
        { label: "Policy", to: "/policyInput" },
      ]}
    >
      <div className="d-flex justify-content-end mb-3 gap-3">
        <>
          <SubmitButton
            title={policyID ? "Update Policy" : "Save Policy"}
            loading={loading}
            onClick={() => {
              if (policyID) {
                updatePolicy(policyID);
              } else {
                newPolicy();
              }
            }}
            color={"success"}
            loaderColor={"white"}
            disabled={
              data.title == "" ||
              data.categoryID == "" ||
              data.description == "" ||
              (data.signature == "" && signatureHandler == '')
            }
          />
        </>
      </div>
      {/* Title */}
      <Box
        sx={{
          display: {
            xs: "block",
            sm: "block",
            md: "flex",
            lg: "flex",
          },
          justifyContent: "space-between",
        }}
      >
        <div className="col-md-12 col-12">
          <div className="card">
            <div className="card-body">
              {/* <Box> */}
              <div className="col-md-12 col-12">
                <h5 className="card-title">Add Policy Title</h5>
                <FormField item={titleField} />
              </div>
              <div className="col-md-12 col-12">
                <h5 className="card-title">Category</h5>
                <FormField item={categoryField} />
              </div>
              {isAdmin && (
                <div className="col-md-12 col-12">
                  <h5 className="card-title">Company</h5>
                  <FormField item={companyField} />
                </div>
              )}
              <h5 className="card-title">Description</h5>
              <Box
                sx={{
                  height: "580px",
                }}
              >
                <ReactQuill
                  style={{
                    height: "500px",
                  }}
                  value={data.description}
                  onChange={handleEditorChange}
                  modules={modules}
                  formats={formats}
                  theme="snow"
                />
              </Box>
              <div className="col-md-12 col-12">
                <h5 className="card-title">Signature Type</h5>
                <FormField item={signatureTypeField} />
              </div>
              {signatureType != "" && (
                <div className="col-md-12 col-12">
                  <h5 className="card-title">Signature</h5>
                  <FormField
                    item={
                      signatureType == "File"
                        ? fileField
                        : signatureType == 'Signature' ? signatureField : signatureTextField
                    }
                  />
                </div>
              )}
              {/* <Box
                sx={{
                  padding: "10px",
                }}
              >
                <FormField
                  item={{
                    value: [signatureHandler],
                    setValue: (value, checkbox) => {
                      setsignatureHandler(value);
                    },
                    type: "signature",
                  }}
                  disabled={false}
                />
              </Box> */}
            </div>
          </div>
        </div>
        {/* <div className="col-md-5 col-12">
          <div className="card">
            <div className="card-body">
              <div className="col-md-12 col-12">
                <h5 className="card-title">Ask AI Assistant</h5>
                <div className="d-flex">
                  <FormField item={assistantField} />
                  <SubmitButton
                    style={{ marginLeft: "15px" }}
                    title={"Search"}
                    loading={loading}
                    onClick={() => {
                      handleAssistentRequest();
                    }}
                    color={"success"}
                    loaderColor={"white"}
                    disabled={false}
                  />
                </div>
                <Box
                  sx={{
                    height: "250px",
                    border: "1px solid #00000012",
                    marginTop: "20px",
                    overflow: "auto",
                    padding: "10px",
                    borderRadius: "10px",
                    position: "relative",
                  }}
                >
                  {aiLoading && (
                    <Box
                      sx={{
                        position: "absolute",
                        top: "0",
                        left: "0",
                        backgroundColor: "rgba(0,0,0,0.2)",
                        height: "100%",
                        width: "100%",
                        zIndex: "999999999999",
                      }}
                    >
                      <Box
                        sx={{
                          position: "absolute",
                          top: "50%",
                          left: "50%",
                          transform: "translate(-50%,-50%)",
                        }}
                      >
                        <Loader loading={aiLoading} center></Loader>
                      </Box>
                    </Box>
                  )}
                  {data.aiResponse}{" "}
                  {(isCompany && data.aiResponse) ==
                    "Disclaimer: Only use AI for inspiration. For accurate & up-to-date advice, " && (
                      <label
                        style={{
                          color: "blue",
                          textDecoration: "underline",
                        }}
                        onClick={() =>
                          navigate(
                            `/profile?companyID=${localStorage.getItem("_id")}`
                            // { state: { tab: "#profile-support" } }
                          )
                        }
                      >
                        Contact us here...
                      </label>
                    )}
                </Box>
                <Box
                  sx={{
                    display: "flex",
                    flexDirection: "row-reverse",
                    marginTop: "15px",
                  }}
                  className="d-flex justify-between"
                >
                  <SubmitButton
                    title={"Add To Description"}
                    loading={loading}
                    onClick={() => {
                      setData({ ...data, description: data.aiResponse });
                    }}
                    color={"success"}
                    loaderColor={"white"}
                    disabled={false}
                  />
                </Box>
              </div>
            </div>
          </div>
        </div> */}
      </Box>
      <div className="col-md-12 col-12">
        <div className="card">
          <div className="card-body">
            <div className="col-md-12 col-12">
              <h5 className="card-title">Autofill List</h5>
              <Grid container>
                {autofillList?.map((item) => (
                  <Grid item xs={12} sm={12} md={6} lg={6}>
                    <li>{item}</li>
                  </Grid>
                ))}
              </Grid>
            </div>
          </div>
        </div>
      </div>
    </Screen>
  );
}
